export default "__VITE_ASSET__vbt7wAIZ__"